<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.casosSuspeitos"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(actions)="{index}">
                <rkm-button
                    v-if="data.model.casosSuspeitos[index]?.geraImpressao"
                    @click="print(data.model.casosSuspeitos[index])"
                    color="secondary"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, file } from '@/mixins'

// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    created() {
        
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Caso suspeito', sortable: true},
            {class: 'col-min text-right', key: 'actions', label: 'Ações'},
        ],
    }),
    mixins: [repository, file],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        print(casoSuspeito) {
            this.setLoading();

            this.repositories.impressao.fichaNotificacao(casoSuspeito.id, {
                tipo: 'ficha_de_notificacao',
                caso_suspeito_id: casoSuspeito.id,
                atendimento_id: this.data.model.atendimentoId,
                cid_id: casoSuspeito.cidId
            })
            .then(({data, headers}) => this.openFile(data, headers['content-type']))
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o caso suspeito?', async () => {
                this.data.model.casosSuspeitos.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>